var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoArrowClockwise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5004 5.96118C8.47404 5.96118 5.21003 9.22519 5.21003 13.2516C5.21003 17.2779 8.47404 20.5419 12.5004 20.5419C16.5268 20.5419 19.7908 17.2779 19.7908 13.2516C19.7908 12.1647 19.5534 11.1352 19.1284 10.2105C18.9602 9.84466 19.1205 9.41177 19.4863 9.24361C19.8521 9.07545 20.285 9.2357 20.4532 9.60154C20.9642 10.7134 21.2488 11.9502 21.2488 13.2516C21.2488 18.0832 17.332 22 12.5004 22C7.66877 22 3.75195 18.0832 3.75195 13.2516C3.75195 8.41992 7.66877 4.5031 12.5004 4.5031V5.96118Z",
    fill: "inherit"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5004 8.09906V2.36522C12.5004 2.05616 12.8609 1.88733 13.0983 2.08518L16.5386 4.95211C16.7135 5.09784 16.7135 5.36644 16.5386 5.51217L13.0983 8.3791C12.8609 8.57695 12.5004 8.40812 12.5004 8.09906Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoArrowClockwise);
export default __webpack_public_path__ + "static/media/ico-arrow-clockwise.1c2e16965e3ed1526edf8a3ded31a388.svg";
export { ForwardRef as ReactComponent };